// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"31270de2","977":"a40c3182"}[chunkId] + ".chunk.js";
};